import React, { useState } from 'react';
import { ELEMENT_TD, ELEMENT_TH, useTableStore } from '@udecode/plate-table';
import {
  useEditorState,
  getPluginOptions,
  findNode,
  setElements,
  isBlock,
  focusEditor,
  useEventPlateId,
} from '@udecode/plate-common';

import ColorPicker from 'components/ColorPicker';
import { KEY_COLOR_PICKER_SETTINGS } from
  'components/PlateEditor/plugins/color-picker-settings/createColorPickerSettingsPlugin';
  import {
    DropdownMenuContent,
  } from '../../components/dropdown-menu/dropdown-menu';


const types = [ELEMENT_TD, ELEMENT_TH];

export const PlateTableBackgroundPicker = ({ id }) => {
  const editor = useEditorState(useEventPlateId(id));
  const [activeElement] = findNode(editor, { match: { type: types } }) || [];
  const { bgColor } = activeElement;
  const selectedCells = useTableStore().get.selectedCells();

  const colorPickerProps = getPluginOptions(editor, KEY_COLOR_PICKER_SETTINGS);
  const { savedColors, usedColors, saveColor, deleteColor } = colorPickerProps || {};
  const [localSavedColors, setLocalSavedColors] = useState(savedColors);

  const applyColor = (value) => {
    const match = (n) => {
      return (
        isBlock(editor, n) &&
        types.includes(n.type)
      );
    };

    // This relies on all cells having id. If that functionality is removed, this won't work.
    if (selectedCells) {
      selectedCells.forEach(cell => {
        const foundCell = findNode(editor, { match: n => n.id === cell.id });
        if (foundCell) {
          setElements(
            editor,
            { bgColor: value },
            { at: foundCell[1], match },
          );
        }
      });
    } else {
      setElements(
        editor,
        { bgColor: value },
        { match },
      );
    }
  };

  const handleColorSelect = (e, value) => {
    e.preventDefault();
    e.stopPropagation();

    applyColor(value);
    setTimeout(() => {
      focusEditor(editor);
    }, 0);
  };

  const handleHexChange = (value) => {
    applyColor(value);
  };

  const handleColorSave = (e, value) => {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }
    if (saveColor) saveColor(value);
    setTimeout(() => {
      focusEditor(editor);
    }, 0);
  };

  const handleSavedColorDelete = (e, value) => {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }
    if (deleteColor) {
      deleteColor(value);
      // Color picker settings isn't from a prop,
      // so we manage colors locally to ensure component updates.
      setLocalSavedColors(localSavedColors.filter(color => color !== value));
    }
  };

  return (
    <DropdownMenuContent
      side="right"
      align="start"
      sideOffset={8}
      className="slate-popover slate-popover--table"
      style={{ zIndex: 40 }}
    >
      <div>
        <ColorPicker
          color={bgColor}
          savedColors={localSavedColors}
          usedColors={usedColors}
          handleColorSelect={handleColorSelect}
          handleColorSave={handleColorSave}
          handleHexChange={handleHexChange}
          handleSavedColorDelete={handleSavedColorDelete}
          hasClearOption
        />
      </div>
    </DropdownMenuContent>
  );
};
